class StickySideBySide {
	constructor() {}

	init(el) {
		const header = el.querySelector('.sxs-sticky-header');
		const lastSlide = el.querySelector('.sides-contain:last-child');

		if (!header || !lastSlide) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					// When the bottom sentinel is NOT intersecting (last slide has exited),
					// release the sticky header so it scrolls away naturally.
					header.classList.toggle('sxs-sticky-header--released', !entry.isIntersecting);
				});
			},
			{
				// Fire when the last slide is fully out of the viewport
				threshold: 0,
				rootMargin: '0px 0px 0px 0px',
			}
		);

		// Observe a sentinel placed at the END of the last slide
		const sentinel = document.createElement('div');
		sentinel.className = 'sxs-sentinel';
		lastSlide.appendChild(sentinel);
		observer.observe(sentinel);
	}
}

window.app.add('stickySideBySide', new StickySideBySide());
